export class BranchRegion{
    code: string;
    name: string;

    constructor(){
        this.code = "";
        this.name = "";
    }
}